import React, { useState } from 'react'
// import { useDispatch } from 'react-redux'
// import * as UIcons from '@iconscout/react-unicons'
import { FormProvider, useForm } from 'react-hook-form'
// import Input from 'components/Input'
import { FormBtn } from 'components/Btn'
import { withTranslation } from 'react-i18next'
// import { TextField } from '@mui/material'
// import { set } from 'date-fns'
import OTPInput from "otp-input-react";

export default withTranslation()(function ReviewForm({ t }) {
  const method = useForm({
    mode: 'all'
  })
  const { setValue } = method

  const [OTP, setOTP] = useState("");


  const change = (value) => {
    console.log(value);
    setOTP(value);
    setValue('otp', OTP);
  }

  const { formState: { isValid, isDirty } } = method

  return (
    <div className="p-5">
      <li className="grid grid-cols-5 text-left px-5 py-2">
        <label className="col-span-3">{t('redemption.review.method')}</label>
        <span className="text-sm col-span-2">Bank transfer</span>
      </li>
      <li className="grid grid-cols-5 text-left px-5 py-2">
        <label className="col-span-3">{t('redemption.review.name')}</label>
        <span className="text-sm col-span-2">Name of bank</span>
      </li>
      <li className="grid grid-cols-5 text-left px-5 py-2">
        <label className="col-span-3">{t('redemption.review.number')}</label>
        <span className="text-sm col-span-2">123456789012343</span>
      </li>
      <li className="grid grid-cols-5 text-left px-5 py-2">
        <label className="col-span-3">{t('redemption.review.description')}</label>
        <span className="text-sm col-span-2">This is the naration</span>
      </li>
      <li className="grid grid-cols-5 text-left px-5 py-2">
        <label className="col-span-3">{t('redemption.review.amount')}</label>
        <span className="text-sm col-span-2">NGN 200.00</span>
      </li>
      <li className="grid grid-cols-5 text-left px-5 py-2">
        <label className="col-span-3 font-semibold text-2xl">{t('redemption.review.total')}</label>
        <span className="text-sm col-span-2">NGN 200.00</span>
      </li>
      <li className="p-5 bg-input m-3 rounded-lg text-sm">
        <p className="mb-2">{t('redemption.otp.explanation.0')} <span className="text-primary font-medium">{t('redemption.otp.explanation.1')}</span></p>
        <p className="mb-2"><span className="font-medium">{t('redemption.otp.remaining')}</span> <span className="text-green">7 minutes and 29 seconds</span></p>
        <p className="mb-2"><span className="font-medium">{t('redemption.otp.input')}</span></p>

        <FormProvider {...method}>
          <form className="grid grid-cols-4 gap-5 mx-auto">
            {/* <Input
              name="otp_1"
              classList="otp"
              variant="filled"
            /> */}
            {/* {otps.map((x, i) => {
              return <input key={i} className='rounded text-center text-[black] h-[50px] focus:border-none font-[700] focus:border-none bg-white'
                variant='filled' style={{ fontSize: '20px' }} name={x.fieldName} {...register(x.fieldName)} value={x.fieldValue} onChange={(e) => change(x.fieldName, e.target.value, i)} />
            })} */}
            {/* <Input
              name="otp_2"
              classList="otp"
              variant="filled"
            />
            <Input
              name="otp_3"
              classList="otp"
              variant="filled"
            />
            <Input
              name="otp_4"
              classList="otp"
              variant="filled"
            /> */}
            <OTPInput value={OTP} onChange={(values) => { change(values) }} autoFocus OTPLength={6} otpType="number" style={{ margin: 'auto' }} disabled={false} className='pl-4 w-[100%] mx-auto' inputClassName='rounded text-center text-[black] h-[50px] focus:border-none font-[700] focus:border-none bg-white' />

            <div className={`bg-primary w-full h-10 overflow-hidden col-span-5 rounded-lg mt-3 ${isValid || isDirty ? 'opacity-50' : ''}`}>

              {/* <ResendOTP onResendClick={() => console.log("Resend clicked")} /> */}
              <FormBtn
                content={() => "Confirm transfer"}
                textColor="text-white"
                className="w-full h-10"
                disabled={isValid || isDirty}
              />
            </div>
          </form>
        </FormProvider>
      </li>
    </div>
  )
})